import { render, staticRenderFns } from "./AdminSignupsChart.vue?vue&type=template&id=b33a841a&scoped=true&"
import script from "./AdminSignupsChart.vue?vue&type=script&lang=js&"
export * from "./AdminSignupsChart.vue?vue&type=script&lang=js&"
import style0 from "./AdminSignupsChart.vue?vue&type=style&index=0&id=b33a841a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33a841a",
  null
  
)

export default component.exports